__webpack_require__.p = "/checkout_static_resources/";